<template>
    <div class="card">
        <div class="card-header">
            个人工作信息管理
        </div>
        <table class="table table-bordered mb-0">
            <tbody>
            <tr>
                <th class="text-center align-middle" style="width: 15%">职务</th>
                <td class="text-left align-middle" style="width: 35%">{{personWorkInfo.post}}</td>
                <th class="text-center align-middle" style="width: 15%">职称</th>
                <td class="text-left align-middle" style="width: 35%">{{personWorkInfo.title}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">院系/部门</th>
                <td class="text-left align-middle" colspan="3">{{personWorkInfo.departmentName}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">研究领域</th>
                <td class="text-left align-middle" colspan="3">{{personWorkInfo.degreeField}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">工作职责</th>
                <td class="text-left align-middle" colspan="3">{{personWorkInfo.dutyDescription}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import userApi from "@/utils/api/user";
export default {
    name: "OrganPersonWorkInfoView",
    props: {
        personId: {type: String, required: true},
    },
    data: function () {
        return {
            personWorkInfo: {},
        };
    },

    mounted() {
        this.getPersonWorkInfo();
    },
    methods: {
        getPersonWorkInfo() {
            userApi.person.work.getOrganWorkInfo(this.personId).then(res => {
                this.personWorkInfo = res.data;
            });
        },
    }
}
</script>

<style scoped>

</style>